/**
 * Created by zuozhuo on 2018/1/24.
 */

import expirePlugin from "store/plugins/expire";
import storeStorage from "store/dist/store.modern";
storeStorage.addPlugin(expirePlugin);

const KEY_PREFIX = `fo-school.`;

// 这里为注销登录会删除的storage, isLogin函数也会删
const USER_DATA_KEYS = {
  // 风险诊断
  riskDiagnosis: KEY_PREFIX + "riskDiagnosis",
  // 登录token
  token: KEY_PREFIX + "token",
  // 登录用户信息 (请勿直接读取localStorage中的profile,不保证准确, 为了保证响应式更新, 请从storeMine.profile读取)
  profile: KEY_PREFIX + "profile",
  // 直播token
  im_token: KEY_PREFIX + "im_token",
  // 微信授权key, 未登录情况没有token, 但是会有key, 所以不应该删
  wxAuthKey: KEY_PREFIX + "wxAuthKey"
};
// 这里为注销登录不会删除的storage
const KEYS = {
  ...USER_DATA_KEYS,
  // 微信授权key, 未登录情况没有token, 但是会有key, 所以不应该删
  wxAuthKey: KEY_PREFIX + "wxAuthKey",
  // 购物车选中的商品
  selectedCartItemIds: KEY_PREFIX + "selectedCartItemIds",
  // 首页数据
  homeData: KEY_PREFIX + "homeData",
  // 邀请人
  inviteMemberId: KEY_PREFIX + "inviteMemberId",
  // 最后一次登录成功用户的手机号 (不一定有, 如在客户端环境下, 所以需要这个数据时, 请另外调用api获取)
  mobile: KEY_PREFIX + "mobile",
  debugSettings: KEY_PREFIX + "debugSettings",
  // 字体大小
  fontSize: KEY_PREFIX + "fontSize",
  // 领取红包的手机号
  mobileForRedPacket: KEY_PREFIX + "mobileForRedPacket",
  // 问答提问数据
  questionData: KEY_PREFIX + "questionData",
  // 播放时长统计
  playerDurations: KEY_PREFIX + "playerDurations",
  // 搜索历史
  searchHistory: KEY_PREFIX + "searchHistory",
  // 搜索单位code历史
  searchCompanyCodeHistory: KEY_PREFIX + "searchCompanyCodeHistory",
  // 登录页面是否使用微信登录
  isWeixinLogin: KEY_PREFIX + "isWeixinLogin",
  // 记录ShortcutNavigation位置
  switchPos: KEY_PREFIX + "switchPos"
};

// 用于替代localStorage, 因为低端安卓机不支持localStorage
/*
 // Store current user
 foStorage.set('user', { name:'Marcus' })

 var expiration = new Date().getTime() + duration
 foStorage.set('foo', 'bar', expiration)

 // Get current user
 foStorage.get('user')

 // Remove current user
 foStorage.remove('user')

 // Clear all keys
 foStorage.clearAll()

 // Loop over all stored values
 foStorage.each(function(value, key) {
 console.log(key, '==', value)
 })

 */

//  var expiration = new Date().getTime() + duration
function setItem(k, v, expiration) {
  verifyKey(k);
  return storeStorage.set(k, v, expiration);
}

function getItem(k) {
  verifyKey(k);
  return storeStorage.get(k);
}

function removeItem(k) {
  verifyKey(k);
  return storeStorage.remove(k);
}

function clearAll() {
  return storeStorage.clearAll();
}

function clearUserData() {
  Object.values(USER_DATA_KEYS).forEach(k => {
    removeItem(k);
  });
}

function getInfo() {
  const keys = storeStorage.map((value, key) => {
    return key;
  });
  return {
    keys
  };
}

function verifyKey(k) {
  if (!k) {
    alert("Storage缓存异常, 请清空缓存重试");
    window.location.reload();
  }
}

const storage = {
  KEYS,
  setItem,
  getItem,
  removeItem,
  clearAll,
  getInfo,
  clearUserData
};

export default storage;



// WEBPACK FOOTER //
// ./src/utils/foStorage.js